export default __webpack_public_path__ + "static/poly-onlite-168x192-76d729bed6bdbfa96f4f9f1f977c6965.svg";